"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumNetLocalNamingRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
class AltiumNetLocalNamingRule {
    constructor(config, namingStrategy) {
        this.config = config;
        this.namingStrategy = namingStrategy;
        this.type = NetNamingRules_1.NetNamingRuleType.LocalNaming;
    }
}
exports.AltiumNetLocalNamingRule = AltiumNetLocalNamingRule;
//# sourceMappingURL=AltiumNetLocalNamingRule.js.map